// Action Types
export const GET_TASK_SETTINGS_REQUEST = 'GET_TASK_SETTINGS_REQUEST';
export const GET_TASK_SETTINGS_SUCCESS = 'GET_TASK_SETTINGS_SUCCESS';
export const GET_TASK_SETTINGS_FAIL = 'GET_TASK_SETTINGS_FAIL';

export const CREATE_TASK_SETTING_REQUEST = 'CREATE_TASK_SETTING_REQUEST';
export const CREATE_TASK_SETTING_SUCCESS = 'CREATE_TASK_SETTING_SUCCESS';
export const CREATE_TASK_SETTING_FAIL = 'CREATE_TASK_SETTING_FAIL';

export const UPDATE_TASK_SETTING_REQUEST = 'UPDATE_TASK_SETTING_REQUEST';
export const UPDATE_TASK_SETTING_SUCCESS = 'UPDATE_TASK_SETTING_SUCCESS';
export const UPDATE_TASK_SETTING_FAIL = 'UPDATE_TASK_SETTING_FAIL';

export const DELETE_TASK_SETTING_REQUEST = 'DELETE_TASK_SETTING_REQUEST';
export const DELETE_TASK_SETTING_SUCCESS = 'DELETE_TASK_SETTING_SUCCESS';
export const DELETE_TASK_SETTING_FAIL = 'DELETE_TASK_SETTING_FAIL';

export const TOGGLE_TASK_SETTING_STATUS_REQUEST = 'TOGGLE_TASK_SETTING_STATUS_REQUEST';
export const TOGGLE_TASK_SETTING_STATUS_SUCCESS = 'TOGGLE_TASK_SETTING_STATUS_SUCCESS';
export const TOGGLE_TASK_SETTING_STATUS_FAIL = 'TOGGLE_TASK_SETTING_STATUS_FAIL';

export const SET_TASK_SETTINGS_LOADING = 'SET_TASK_SETTINGS_LOADING';

// Action Creators
export const getTaskSettingsRequest = () => ({
    type: GET_TASK_SETTINGS_REQUEST
});

export const getTaskSettingsSuccess = (settings) => ({
    type: GET_TASK_SETTINGS_SUCCESS,
    payload: settings
});

export const getTaskSettingsFail = (error) => ({
    type: GET_TASK_SETTINGS_FAIL,
    error
});

export const createTaskSettingRequest = (settingData) => ({
    type: CREATE_TASK_SETTING_REQUEST,
    payload: settingData
});

export const createTaskSettingSuccess = (setting) => ({
    type: CREATE_TASK_SETTING_SUCCESS,
    payload: setting
});

export const createTaskSettingFail = (error) => ({
    type: CREATE_TASK_SETTING_FAIL,
    error
});

export const updateTaskSettingRequest = (id, settingData) => ({
    type: UPDATE_TASK_SETTING_REQUEST,
    payload: { id, settingData }
});

export const updateTaskSettingSuccess = (setting) => ({
    type: UPDATE_TASK_SETTING_SUCCESS,
    payload: setting
});

export const updateTaskSettingFail = (error) => ({
    type: UPDATE_TASK_SETTING_FAIL,
    error
});

export const deleteTaskSettingRequest = (id) => ({
    type: DELETE_TASK_SETTING_REQUEST,
    payload: { id }
});

export const deleteTaskSettingSuccess = (id) => ({
    type: DELETE_TASK_SETTING_SUCCESS,
    payload: { id }
});

export const deleteTaskSettingFail = (error) => ({
    type: DELETE_TASK_SETTING_FAIL,
    error
});

export const toggleTaskSettingStatusRequest = (id) => ({
    type: TOGGLE_TASK_SETTING_STATUS_REQUEST,
    payload: { id }
});

export const toggleTaskSettingStatusSuccess = (setting) => ({
    type: TOGGLE_TASK_SETTING_STATUS_SUCCESS,
    payload: setting
});

export const toggleTaskSettingStatusFail = (error) => ({
    type: TOGGLE_TASK_SETTING_STATUS_FAIL,
    error
});

export const setTaskSettingsLoading = (loading) => ({
    type: SET_TASK_SETTINGS_LOADING,
    payload: loading
});
